import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127')
];

export const server_loads = [];

export const dictionary = {
		"/": [31],
		"/about-us": [84],
		"/affiliate": [85,[20]],
		"/aml-policy": [86],
		"/betfeed": [87],
		"/blog": [88],
		"/bonus-terms": [89],
		"/calendar": [90],
		"/casino": [91],
		"/complaints-and-arbitration": [92],
		"/contact": [93],
		"/fairness": [94],
		"/faq": [95],
		"/faq/[section]": [96],
		"/game-group/[slug=slug]": [98,[22]],
		"/game/[game]": [97,[21]],
		"/in": [99],
		"/in/[actionSlug]": [100],
		"/kyc-policy": [101],
		"/leaderboard": [102],
		"/originals": [103],
		"/originals/[game]": [104,[23]],
		"/payment-policy": [107],
		"/privacy-policy": [108],
		"/promotion-page": [109],
		"/promotion-page/race/[...id]": [111,[27]],
		"/promotion-page/[...id]": [110,[26]],
		"/providers": [112],
		"/p/[provider]": [105,[24]],
		"/p/[provider]/[game]": [106,[24,25]],
		"/races/current": [114],
		"/races/last": [115],
		"/races/next": [116],
		"/races/[raceId]": [113],
		"/referral": [117],
		"/responsible-gaming": [118],
		"/(call-request)/sizi-arayalim": [32,[2]],
		"/special-bets": [120],
		"/special": [119,[28]],
		"/sports": [121,[29]],
		"/sports/[...slug]": [122,[29,30]],
		"/terms-of-service": [123],
		"/terms-sports": [124],
		"/tournaments": [125],
		"/transparency": [126],
		"/vip": [127],
		"/[provider=provider]": [82,[18]],
		"/[lang=lang]": [35,[4]],
		"/[category=category]": [34,[3]],
		"/[lang=lang]/about-us": [41,[4]],
		"/[lang=lang]/affiliate": [42,[4,9]],
		"/[lang=lang]/aml-policy": [43,[4]],
		"/[lang=lang]/betfeed": [44,[4]],
		"/[lang=lang]/blog": [45,[4]],
		"/[lang=lang]/bonus-terms": [46,[4]],
		"/[lang=lang]/calendar": [47,[4]],
		"/[lang=lang]/casino": [48,[4]],
		"/[lang=lang]/complaints-and-arbitration": [49,[4]],
		"/[lang=lang]/contact": [50,[4]],
		"/[lang=lang]/fairness": [51,[4]],
		"/[lang=lang]/faq": [52,[4]],
		"/[lang=lang]/faq/[section]": [53,[4]],
		"/[lang=lang]/game/[game]": [54,[4,10]],
		"/[lang=lang]/kyc-policy": [55,[4]],
		"/[lang=lang]/leaderboard": [56,[4]],
		"/[lang=lang]/originals": [57,[4]],
		"/[lang=lang]/originals/[game]": [58,[4,11]],
		"/[lang=lang]/payment-policy": [61,[4]],
		"/[lang=lang]/privacy-policy": [62,[4]],
		"/[lang=lang]/promotion-page": [63,[4]],
		"/[lang=lang]/promotion-page/race/[...id]": [65,[4,15]],
		"/[lang=lang]/promotion-page/[...id]": [64,[4,14]],
		"/[lang=lang]/providers": [66,[4]],
		"/[lang=lang]/p/[provider]": [59,[4,12]],
		"/[lang=lang]/p/[provider]/[game]": [60,[4,12,13]],
		"/[lang=lang]/races/current": [68,[4]],
		"/[lang=lang]/races/last": [69,[4]],
		"/[lang=lang]/races/next": [70,[4]],
		"/[lang=lang]/races/[raceId]": [67,[4]],
		"/[lang=lang]/referral": [71,[4]],
		"/[lang=lang]/responsible-gaming": [72,[4]],
		"/[lang=lang]/(call-request)/sizi-arayalim": [36,[4,5]],
		"/[lang=lang]/special-bets": [74,[4]],
		"/[lang=lang]/special": [73,[4,16]],
		"/[lang=lang]/sports": [75,[4]],
		"/[lang=lang]/sports/[...slug]": [76,[4,17]],
		"/[lang=lang]/terms-of-service": [77,[4]],
		"/[lang=lang]/terms-sports": [78,[4]],
		"/[lang=lang]/tournaments": [79,[4]],
		"/[lang=lang]/transparency": [80,[4]],
		"/[lang=lang]/vip": [81,[4]],
		"/[lang=lang]/[provider=provider]": [39,[4,7]],
		"/[lang=lang]/[category=category]": [38,[4,6]],
		"/[lang=lang]/[provider=provider]/[game]": [40,[4,7,8]],
		"/[provider=provider]/[game]": [83,[18,19]],
		"/[lang=lang]/[...fallback]": [37,[4]],
		"/[...fallback]": [33]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';